import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { DisclaimerContainer } from '@app/pmi/src/containers/DisclaimerContainer';

import { useRemoteAccess } from '@lib/core/retailers/hooks/useRemoteAccess';
import { useRetailer } from '@lib/core/retailers/hooks/useRetailer';
import { actionValidateOpenIntegration } from '@lib/core/retailers/slices/remoteAccess';

import { InvalidVerificationLinkGate } from '@components/pmi/src/common/InvalidVerificationLinkGate';
import { Spinner } from '@components/pmi/src/common/Spinner';

export const OpenIntegrationContainer = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const { retailerId } = useRetailer();
  const { isRemoteAccessLoading, isRemoteAccessValid } = useRemoteAccess();

  useEffect(() => {
    const cipherText = searchParams.get('query');
    if (cipherText) {
      dispatch(
        actionValidateOpenIntegration({
          ciphertext: decodeURIComponent(cipherText),
          custom_id: 'open_integration',
          retailer_identifier: retailerId,
        }),
      );
    }
  }, []);

  if (isRemoteAccessLoading || !isRemoteAccessValid) return <Spinner />;

  return isRemoteAccessValid ? <DisclaimerContainer /> : <InvalidVerificationLinkGate />;
};
